import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from './ui';

function homePathForRole(role) {
  if (role === 'admin') return '/dashboard';
  if (role === 'driver') return '/driver/dashboard';
  if (role === 'operator') return '/operator/dashboard';
  return '/main';
}

/** Login/register — redirect home if already authenticated */
export default function GuestRoute({ children }) {
  const { user, isBooting } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isBooting && user) {
      navigate(homePathForRole(user.role), { replace: true });
    }
  }, [isBooting, user, navigate]);

  if (isBooting || user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0f1a14]">
        <Spinner size="md" />
      </div>
    );
  }

  return children;
}
